import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import ConsultationForm from '../components/ConsultationForm';
import FloatingConsultationButton from '../components/FloatingConsultationButton';

const HomePage = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Hero />
      <section className="py-24 bg-black/95">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Our Signature Aesthetic</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              At Advance Elegance Studio, we blend artistry with precision to create timeless imagery that captures the essence of luxury and sophistication.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-12">
            {[
              {
                title: "Timeless Design",
                description: "Creating enduring visual narratives that transcend trends."
              },
              {
                title: "Premium Craftsmanship",
                description: "Meticulous attention to detail in every frame we capture."
              },
              {
                title: "Personalized Elegance",
                description: "Tailored photography solutions for discerning clients."
              }
            ].map((pillar, index) => (
              <div key={index} className="p-8 border border-gray-800 rounded-lg hover:border-emerald-400 transition-colors">
                <h3 className="text-xl font-bold mb-4">{pillar.title}</h3>
                <p className="text-gray-400">{pillar.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Services />
      <Portfolio />
      <Testimonials />
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Latest Blog Insights</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Discover the latest trends, techniques, and stories from the world of luxury photography.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "The Art of Luxury Photography",
                excerpt: "Exploring the elements that define premium visual storytelling.",
                image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              },
              {
                title: "Mastering Event Photography",
                excerpt: "Tips and techniques for capturing memorable moments.",
                image: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              },
              {
                title: "The Perfect Shot",
                excerpt: "Behind the scenes of our most iconic photographs.",
                image: "https://images.unsplash.com/photo-1452587925148-ce544e77e70d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              }
            ].map((post, index) => (
              <Link to="/blog" key={index} className="group">
                <div className="relative overflow-hidden rounded-lg">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-[250px] object-cover transform group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent">
                    <div className="absolute bottom-0 p-6">
                      <h3 className="text-xl font-bold mb-2">{post.title}</h3>
                      <p className="text-gray-300">{post.excerpt}</p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Contact />
      <ConsultationForm 
        isOpen={isConsultationOpen} 
        onClose={() => setIsConsultationOpen(false)} 
      />
      <FloatingConsultationButton onOpen={() => setIsConsultationOpen(true)} />
    </motion.div>
  );
};

export default HomePage;